module.exports = __webpack_public_path__ + "img/bolts.d34bfffa.svg";